<template>
    <section class="section-flow">
        <div class="content">
            <div class="title-section">{{webInfo.webName}}平台全流程亮点</div>

            <img
                class="img-flow"
                :src="webInfo.home.ptlc"
                alt=""
            />
        </div>
    </section>
</template>


<script>
export default {
    data() {
        return {
           
        };
    },
    methods: {
        
    },
    mounted(){
        
    },
};
</script>

<style lang="scss" scoped>
.section-flow {
    padding-bottom: 98px;
    background-image: url(/images/hzc/home/bg-flow.png);
    background-size: cover;
    background-position: center center;

    .title-section {
        padding: 78px 0;
        font-weight: normal;
    }

    .img-flow{
        display: block;
        width: 1082px;
        margin: 0 auto;
    }
}
</style>